// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Banese — COMPE 047 */
export const Banese = createBankIcon({
  name: "Banese",
  slug: "banese",
  compe: "047",
  color: "#00622a",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#00622a;fill-opacity:1\"\n     id=\"banese_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(0.0000,-0.0600) scale(0.02999)\">\n    <path d=\"M 777.811084161664,1169.90820852422 C 777.811084161664,1169.90820852422 893.763969886664,589.0958741782201 1511.254001036664,698.9964192172201 C 2128.733667736664,808.9038406702201 2613.426588256664,1062.2534604822201 3238.495324716664,530.9745283282201 C 3238.495324716664,530.9745283282201 3106.281613046664,1047.90637049022 2427.694542568664,1147.82545159522 C 1749.128400307664,1247.7550964666202 1439.913695749664,881.5643178162202 777.8110841686639,1169.90820852422 L 777.811084161664,1169.90820852422\" style=\"fill:#ffffff\" />\n  </g>",
});
